/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Tooltip } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import PersonIcon from '@material-ui/icons/Person';
import LinearProgress from '@material-ui/core/LinearProgress';
import PhoneIcon from '@material-ui/icons/Phone';
import DoneAllIcon from '@material-ui/icons/DoneAll';

import _ from '../../../utils/lodash';
import useTimeline from '../timeline/useTimeline';
import { SearchFilter } from '../Filters/SearchFilter';
import { SortOptionsDialog } from '../Filters/SortOptionsDialog';
import { sortTreatmentOptions, sortingIconMap } from '../timeline/timelineConstants';
import { checkFeatureAccess } from '../../../utils/helpers';
import globals from '../../../globals/communityGlobals';
import { DayPeriod, VisitType, compareRag } from '../../../enums';
import TimelineDockerPanel from '../timeline/TimelineDockerPanel';
import { highlightAvailableSlots } from '../timeline/timelineHelper';

const style = {
  root: {
    minWidth: 500,
  },
};

const useStyles = makeStyles({
  clinicianPopModal: {
    backgroundColor: '#333333',
    color: '#fff',
    padding: '5px',
    minWidth: '135px',
  },
});

// eslint-disable-next-line react/prop-types
export default function TreatmentInstances({
  baseRequestModel,
  clinicianIds,
  treatmentInstances,
  filteredTreatmentInstances,
  filteredCancelledTreatmentInstances,
  isAdvanceFilterActive,
  toggleRefresh,
  includeTreatments,
  isNotClickable,
  isMultiAssign,
  setIsMultiAssign,
}) {
  const [patientFilterPhrase, setPatientFilterPhrase] = useState('');
  const classes = useStyles();
  const [treatmentFilterOption, setTreatmentFilterOption] = useState(1);
  const [treatmentSortingOptions, setTreatmentSortingOptions] = useState(sortTreatmentOptions);
  const [showMoreAnchor, setShowMoreAnchor] = useState(null);
  const [loadingTimeSlots, setLoadingTimeSlots] = useState({ treatmentId: null, timeSlotId: null, value: false });

  const faList = useSelector(store => store.global.auth.featureAccessList);
  const {
    getFlag,
    resetTreatmentClickEvent,
    activeTreatment,
    setActiveUnassignedTreatment,
    setActiveTreatment,
    getAccessToken,
    getAvailableTimeSpans,
    resetContextAndModify,
    getMultiSelectedTreatments: multiSelectedTreatments,
    setMultiSelectedTreatments,
  } = useTimeline();

  const filteredData = _.remove(
    isAdvanceFilterActive
      ? [...filteredTreatmentInstances, ...filteredCancelledTreatmentInstances]
      : [...treatmentInstances],
    x =>
      patientFilterPhrase === '' ||
      x.patientName.toLowerCase().indexOf(patientFilterPhrase) !== -1 ||
      x.nhsNumber.toLowerCase().indexOf(patientFilterPhrase) !== -1,
  );

  const handleTreatmentClick = item => {
    setIsMultiAssign(false);
    if (activeTreatment && activeTreatment.treatmentId === item.treatmentId) {
      setActiveTreatment(null);
    } else if (checkFeatureAccess(faList, globals.applicationFeatureAccesses.canAllocateWork)) {
      const model = {};
      model.clinicianIds = clinicianIds;
      model.treatmentId = item.treatmentId;
      model.TimeSlotId = item.timeSlotId;

      highlightAvailableSlots(
        false,
        item,
        _.merge(model, baseRequestModel),
        setLoadingTimeSlots,
        getFlag,
        resetTreatmentClickEvent,
        setActiveTreatment,
        getAccessToken,
      );
    }
  };

  const handleOpenPanel = (e, item) => {
    e.stopPropagation();
    const treatment = _.cloneDeep(item) || {};
    setActiveUnassignedTreatment(treatment);
  };

  const handleMultiSelect = item => {
    if (!multiSelectedTreatments.some(t => t.treatmentId === item.treatmentId && t.timeSlotId === item.timeSlotId)) {
      setMultiSelectedTreatments([
        ...multiSelectedTreatments,
        {
          treatmentId: item.treatmentId,
          nhsNumber: item.nhsNumber,
          patientName: item.patientName,
          timeSlotId: item.timeSlotId,
          treatmentInstanceId: item.treatmentInstanceId != null ? item.treatmentInstanceId : -1,
          treatmentInstanceActivities: item.treatmentInstanceActivities,
          treatmentPostcode: item.postcode,
          orgUnitId: baseRequestModel.OrgUnitId,
          selectedDate: baseRequestModel.SelectedDate,
          treatmentTimeType: item.treatmentTimeType,
          timeSlots: item.timeSlots,
          masterId: item.masterId,
          visitType: item.visitType,
          isBundled: item.isBundled,
        },
      ]);
    } else {
      setMultiSelectedTreatments(
        multiSelectedTreatments.filter(e => e.treatmentId !== item.treatmentId || e.timeSlotId !== item.timeSlotId),
      );
    }

    if (isMultiAssign) {
      setIsMultiAssign(false);
    }
  };

  const hasTimeSlots = getFlag('enableMultipleSelection')
    ? _.some(getAvailableTimeSpans().clinicianTimeSpans, item => item.timeSpans.length > 0)
    : _.some(getAvailableTimeSpans(), item => item.timeSpans.length > 0);

  const treatmentRender = item => {
    const isTreatmentInstanceCancelled = item.isCancelled;
    const isAssignable = 1;
    const ragStatus = item.ragStatus.name.toLowerCase();
    const isSpecific = item.isSingleTimeSlot && item.treatmentTimeType === 'SpecificTime';

    const isLoading =
      loadingTimeSlots.value &&
      loadingTimeSlots.treatmentId === item.treatmentId &&
      loadingTimeSlots.timeSlotId === item.timeSlotId;

    const timeSlotColor = classNames({
      specificTimeSlot: isSpecific,
      singleTimeSlot: item.isSingleTimeSlot && !isSpecific,
      multipleTimeSlot: !item.isSingleTimeSlot,
      'is-copy': item.masterId,
    });

    const isTreatmentSelected = activeTreatment
      ? activeTreatment.treatmentId === item.treatmentId && activeTreatment.timeSlotId === item.timeSlotId
      : false;

    const multiSelectTreatment = multiSelectedTreatments
      ? getFlag('enableMultipleSelection') &&
        multiSelectedTreatments.some(t => t.treatmentId === item.treatmentId && t.timeSlotId === item.timeSlotId)
      : false;

    const treatmentClass = classNames('treatment-details', {
      'active-treatment': isTreatmentSelected && !getFlag('enableMultipleSelection'),
      'with-no-timeslots': !hasTimeSlots && !getFlag('enableMultipleSelection'),
      'selected-default': !getFlag('enableMultipleSelection') && isLoading,
      'multiSelect-treatment': multiSelectTreatment,
      'disabled-card': getFlag('enableMultipleSelection') && item.masterId,
      'canceled-visit': isTreatmentInstanceCancelled,
    });

    const isLoadingMultiple =
      loadingTimeSlots.value && multiSelectedTreatments.some(x => x.treatmentId === loadingTimeSlots.treatmentId);

    const isTreatmentMultiSelected =
      multiSelectedTreatments.filter(x => x.treatmentId === item.treatmentId && x.timeSlotId === item.timeSlotId)
        .length === 1;

    const treatmentsClass = classNames('treatment-details', {
      'multiSelect-treatment': multiSelectTreatment,
      'active-treatment with-no-timeslots': !isLoadingMultiple && !hasTimeSlots && isTreatmentMultiSelected,
      'selected-default': isLoadingMultiple && isTreatmentMultiSelected,
    });

    const numberOfCliniciansClass = classNames('treatment-info', {
      'copies-in-other-unit': item.numberOfClinicians > item.numberOfCliniciansInOrgUnit,
    });

    return (
      <div
        style={{
          pointerEvents: isNotClickable ? 'none' : 'visible',
        }}
        key={
          !isTreatmentInstanceCancelled
            ? `${item.treatmentId}_${item.timeSlotId}`
            : `${item.treatmentId}_${item.treatmentInstanceId}`
        }
        className={isMultiAssign ? treatmentsClass : treatmentClass}
        onClick={
          isTreatmentInstanceCancelled
            ? null
            : getFlag('enableMultipleSelection')
            ? () => handleMultiSelect(item)
            : isAssignable
            ? () => handleTreatmentClick(item)
            : null
        }
      >
        <Box display="flex" p={0}>
          <Box p={0.5} flexGrow={0} style={{ padding: '4px 0px 4px 0' }}>
            <div className={`timeslots ${timeSlotColor}`} />
          </Box>
          {isLoading && (
            <div className="progressBar">
              <LinearProgress />
            </div>
          )}
          <Box p={0.5} flexGrow={1} style={{ position: 'relative' }}>
            <Box display="flex" justifyContent="space-between">
              <Box className="treatment-details-card">
                <div className={`rag-status rag-status-${ragStatus}`} />
                <Box display="flex" alignItems="center">
                  <Typography className="ellipsis patientName" variant="h5">
                    {item.patientName}
                  </Typography>
                  <Typography className="patient-band" variant="subtitle2">
                    {item.band}
                  </Typography>
                  {item.dayPeriod === DayPeriod.AM && (
                    <Typography className="am-sign" variant="subtitle2">
                      AM
                    </Typography>
                  )}
                  {item.dayPeriod === DayPeriod.PM && (
                    <Typography className="pm-sign" variant="subtitle2">
                      PM
                    </Typography>
                  )}
                  {item.isBundled && (
                    <Box display="flex" px={0.5}>
                      <span className="icon-extend icon-bundle-visits icon-small icon-info-color" />
                    </Box>
                  )}
                </Box>
                <Box display="flex" mt={0.5}>
                  <Typography className="ellipsis activity-name" variant="subtitle1">
                    {item.activities}
                  </Typography>
                  {item.numberOfActivities > 1 && (
                    <span className="numberOf-activities">{item.numberOfActivities - 1}</span>
                  )}
                </Box>

                <Typography className="nhsNumber" variant="subtitle1">
                  {item.nhsNumber}
                </Typography>

                <Box className="icons-row" p={0} mt={0.5} display="flex" alignItems="flex-end">
                  <Box className="treatment-info">
                    <Typography className="aligned-icon" variant="subtitle1" style={{ lineHeight: '23px' }}>
                      {item.visitType === VisitType.PhoneCall ? (
                        <React.Fragment>
                          <PhoneIcon fontSize="small" />
                          {item.contactNumber}
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <LocationOnIcon fontSize="small" />
                          {item.postcode}
                        </React.Fragment>
                      )}
                    </Typography>
                  </Box>
                  <Box className="treatment-info" data-duration={item.totalTime}>
                    <Typography className="aligned-icon" variant="subtitle1" style={{ lineHeight: '23px' }}>
                      <AccessTimeIcon fontSize="small" />
                      {item.totalTime}
                    </Typography>
                  </Box>
                  <Box
                    className={numberOfCliniciansClass}
                    data-clinicians={item.numberOfClinicians - item.numberOfAssignedClinicians}
                  >
                    <Typography className="aligned-icon" variant="subtitle1" style={{ lineHeight: '23px' }}>
                      <PersonIcon fontSize="small" />
                      {item.numberOfClinicians - item.numberOfAssignedClinicians}
                    </Typography>
                  </Box>
                  {item.isReviewDate && (
                    <Box ml={0.5} className="treatment-info review-icon-box">
                      <Typography className="aligned-icon" variant="subtitle1" style={{ lineHeight: '23px' }}>
                        <span className="icon-review icon-svg asw-icon" />
                      </Typography>
                    </Box>
                  )}
                  {item.unassignSourceBySystem && (
                    <Box className="treatment-info unassigned-icon-box">
                      <Typography className="aligned-icon" variant="subtitle1" style={{ lineHeight: '23px' }}>
                        <span className="icon-unassigned icon-svg asw-icon" />
                      </Typography>
                    </Box>
                  )}
                  {item.preferredClinicianId && item.masterId === null && (
                    <Box className="treatment-info preferred-clinician">
                      <Typography variant="subtitle1" style={{ lineHeight: '13px' }}>
                        <span className="icon-extend icon-person-star icon-small" />
                      </Typography>
                    </Box>
                  )}
                  <Box alignSelf="flex-end" className="treatment-info">
                    <Typography className="aligned-icon " variant="subtitle1" onClick={e => handleOpenPanel(e, item)}>
                      <span className="icon-extend icon-info-more icon-small" />
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </div>
    );
  };

  const setFilterValue = (name, value) => {
    setTreatmentFilterOption(value);
    const sortedList = treatmentSortingOptions.map(cl => {
      if (cl.id === value) {
        return {
          ...cl,
          name: (
            <span>
              {`✓ ${cl.label}`} <i className={!cl.isAsc ? sortingIconMap.ASC : sortingIconMap.DESC} />
            </span>
          ),
          isAsc: !cl.isAsc,
        };
      }
      return {
        ...cl,
        name: cl.label,
        isAsc: false,
      };
    });
    setTreatmentSortingOptions(sortedList);
  };

  const toggleMultiSelect = () =>
    resetContextAndModify({
      flags: { enableMultipleSelection: !getFlag('enableMultipleSelection'), showLegend: getFlag('showLegend') },
    });

  // Sorting the filtered data source
  const selectedSortingOption = treatmentSortingOptions.find(o => o.id === treatmentFilterOption);
  const isAsc = selectedSortingOption.isAsc;
  const updatedData = filteredData.sort((a, b) => {
    const propertyName = selectedSortingOption.propertyName;
    if (propertyName === 'ragStatus') {
      const compare = compareRag(a[propertyName].name, b[propertyName].name);
      if (isAsc) return compare;
      if (!isAsc) return -compare;
    } else {
      if (isAsc && a[propertyName] > b[propertyName]) return 1;
      if (!isAsc && a[propertyName] < b[propertyName]) return 1;
      if (isAsc && a[propertyName] < b[propertyName]) return -1;
      if (!isAsc && a[propertyName] > b[propertyName]) return -1;
    }
    return 0;
  });

  const renderFilterSection = () => {
    return (
      <div className="timeline-sub-cards-header">
        <div className="timeline-input-wrapper timeline-select-input">
          <div className="timeline-form-map-input">
            <SearchFilter
              width="100%"
              label="Find Patient"
              fullWidth
              filterValue={patientFilterPhrase}
              onChange={(name, value) => setPatientFilterPhrase(value)}
              id="treatment_search"
            />
            <span className="icon-extend icon-search icon-small" />
          </div>

          <div className="form-map-icon">
            <Tooltip title="Sorting">
              <span
                id="sort-treatment-instances"
                className="icon-extend icon-sorting icon-small"
                onClick={event => setShowMoreAnchor(event.target)}
              />
            </Tooltip>
            <SortOptionsDialog
              clinicianModal={classes.clinicianPopModal}
              style={style}
              open={showMoreAnchor !== null}
              anchorEl={showMoreAnchor}
              handleClose={() => setShowMoreAnchor(null)}
              width="100%"
              fullWidth
              data={treatmentSortingOptions}
              filterKey={'sortTreatmentFilter'}
              filterValue={treatmentFilterOption || treatmentSortingOptions[0].id}
              onChange={(name, value) => setFilterValue(name, value)}
            />
          </div>
          <div className={`multiselect-icon ${getFlag('enableMultipleSelection') ? 'multiselect-btn' : null}`}>
            <Tooltip title="Multiselect visits">
              <span type="button" onClick={toggleMultiSelect}>
                <DoneAllIcon fontSize="small" />
              </span>
            </Tooltip>
          </div>
        </div>
      </div>
    );
  };

  const selectAllTreatments = () => {
    setMultiSelectedTreatments(
      updatedData
        .filter(item => !item.masterId)
        .map(t => {
          return {
            treatmentId: t.treatmentId,
            patientName: t.patientName,
            timeSlotId: t.timeSlotId,
            treatmentInstanceId: t.treatmentInstanceId != null ? t.treatmentInstanceId : -1,
          };
        }),
    );
  };

  return (
    <div className="clinician-treatments-container">
      <React.Fragment>
        {renderFilterSection()}
        <div className="tbody">
          {updatedData.length ? (
            updatedData.map(treatmentRender)
          ) : (
            <div className="no-data-text">No patients available</div>
          )}
        </div>
        {multiSelectedTreatments.length > 0 && (
          <TimelineDockerPanel
            items={multiSelectedTreatments}
            clinicianIds={clinicianIds}
            toggleRefresh={toggleRefresh}
            includeTreatments={includeTreatments}
            onCancel={toggleMultiSelect}
            onSelectAll={selectAllTreatments}
            setLoadingTimeSlots={setLoadingTimeSlots}
            setIsMultiAssign={setIsMultiAssign}
            isMultiAssign={isMultiAssign}
            baseRequestModel={baseRequestModel}
          />
        )}
      </React.Fragment>
    </div>
  );
}
